import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/auth.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "loader",
    pathMatch: "full",
  },
  {
    path: "loader",
    loadChildren: () =>
      import("./loader/loader.module").then((m) => m.LoaderPageModule),
  },
  {
    path: "walkthrough",
    loadChildren: () =>
      import("./walkthrough/walkthrough.module").then(
        (m) => m.WalkthroughPageModule
      ),
  },
  {
    path: "login-sms",
    loadChildren: () =>
      import("./login-sms/loginsms.module").then((m) => m.LoginSMSPageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "getting-started",
    loadChildren: () =>
      import("./getting-started/getting-started.module").then(
        (m) => m.GettingStartedPageModule
      ),
  },
  {
    path: "user/profile",
    loadChildren: () =>
      import("./user/update-profile/profile.module").then(
        (m) => m.ProfilePageModule
      ),
  },
  {
    path: "user/create",
    loadChildren: () =>
      import("./user/new-profile/create-user.module").then(
        (m) => m.CreateUserPageModule
      ),
  },
  {
    path: "patient/profile",
    loadChildren: () =>
      import("./patient/update-patient/update-patient.module").then(
        (m) => m.UpdatePatientPageModule
      ),
  },
  {
    path: "patient/create",
    loadChildren: () =>
      import("./patient/new-patient/create-patient.module").then(
        (m) => m.CreatePatientPageModule
      ),
  },
  {
    path: "connect/relative",
    loadChildren: () =>
      import("./connect/relative/relatives.module").then(
        (m) => m.RelativesPageModule
      ),
  },
  {
    path: "connect/consultantProf",
    loadChildren: () =>
      import("./connect/consultant/prof/profs.module").then(
        (m) => m.ConsultantProfsPageModule
      ),
  },
  {
    path: "connect/consultantClient",
    loadChildren: () =>
      import("./connect/consultant/client/clients.module").then(
        (m) => m.ConsultantClientsPageModule
      ),
  },
  /*{
    path: 'connect/create',
    loadChildren: () => import('./patient/new-patient/create-patient.module').then(m => m.CreatePatientPageModule)
  }, */
  {
    path: "home",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "about",
    loadChildren: () =>
      import("./about/about.module").then((m) => m.AboutPageModule),
  },
  {
    path: "page-not-found",
    loadChildren: () =>
      import("./page-not-found/page-not-found.module").then(
        (m) => m.PageNotFoundModule
      ),
  },
  { path: "**", redirectTo: "page-not-found" },
  //{
  //  path: 'profile',
  //  loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  //}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
